export const Url = {
  hp: 'https://sacri.jp/',
  company: 'https://sacri.jp/company/',
  support: 'https://sacrisupport.zendesk.com/hc/ja/requests/new',
  faq: 'https://sacrisupport.zendesk.com/hc/ja',
  terms: 'https://sacri.jp/terms/',
  privacy: 'https://sacri.jp/privacypolicy/',
};
